import {FormArray, FormBuilder} from '@angular/forms';
import {TranslocoService} from '@jsverse/transloco';
import {Observable} from 'rxjs';
import {GlobalService} from '../../../../../global/global.service';
import {IUploadPdfFilesForm} from './upload-file/upload-file.component';
import {IImportFileRequestParams, IUploadFilesService} from './upload-files.service';

export class UploadPDFUpload {
    uploadForm = this.formBuilder.group({
        files: this.formBuilder.array<IUploadPdfFilesForm>([])
    });

    constructor(protected formBuilder: FormBuilder, protected uploadService: IUploadFilesService, protected globalService: GlobalService, protected translocoService: TranslocoService) {
    }

    protected uploadPdfFile<T = IImportFileRequestParams>(additionalParams?:T):Observable<IUploadPdfFilesForm[]> {
        
        return new Observable(observer => {
            if (this.uploadForm.valid) {
                observer.next(this.uploadForm.value.files);
                const filesFormArray = this.uploadForm.get('files') as FormArray;
                this.uploadForm.value.files.forEach(({file, document_type_id, category_ids, contract_card_ids}, index) => {
                    const fileControl = filesFormArray.at(index);
                    const progressControl = fileControl?.get('progress');

                    this.uploadService.uploadFile(file, {
                        category_ids: category_ids, document_type_id: document_type_id, contract_card_ids:contract_card_ids,
                        ...additionalParams
                    })

                        .subscribe({
                            next: x => {
                                progressControl?.setValue(x.percent);
                                observer.next(this.uploadForm.value.files);
                            }, error: (error) => {
                                progressControl?.setValue(0);
                                fileControl?.setErrors({uploadFailed: `${this.translocoService.translate('File upload error (upload files) - File upload failed')}\n${error?.message || ''}`});
                                fileControl?.setErrors({'uploadFailed': this.translocoService.translate('File upload error (upload files) - File upload failed')});
                                this.globalService.toastrError(this.translocoService.translate('File upload failed toast (upload files) - Upload <file_name> file failed', {name: file.name}));
                                observer.error(error);
                            }
                        });
                });
            }
        })
    }
}
